import { EgretLoadable } from "egret";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false,
      showcontent: true,
    },
    navbar: { show: false },
    leftSidebar: {
      show: true,
      mode: "compact",
    },
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false,
    },
    navbar: { show: false },
  },
  secondarySidebar: { show: false },
  footer: { show: false },
  partnerView: false,
};

const Reports = EgretLoadable({
  loader: () => import("./index"),
});

const reportRoutes = [
  {
    path: "/reports",
    component: Reports,
    settings,
  },
];

export default reportRoutes;
